import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import Switch from "react-switch";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";

// Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  Fn_ChangeStateValue,
} from "../../store/functions";

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");

  return d2;
};

class Screen3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      formData: {},
      activeTab: 1,
      passedSteps: [1],
      BrowseImage1: "",
      BrowseImage2: "",
      UserImage: "",
      Signature: "",
      //dropdowns
      membershipType: [],
      maritalStatus: [],
      bloodGroup: [],
      gender: [],
      education: [],
      profession: [],
      relationShip: [],
      nationality: [],
      typeofRegCert: [],
      memberid: 0,
      name: "",
      email: "",
      aid: 0,
      fo3: false,
      Gender: 0,
      MaritalStatus: 0,
      success_msg: false,
      F_MISScheme: 0,
      IsOvertime: false,
      EmpBasic: [],
      searchText: '',
      idType: 'UID',
      aadhaarNumber: '',
      consentChecked: false
    };
    this.obj = this;
    this.nameFieldRef = React.createRef();
    this.formTitle = "User";
    this.breadCrumbTitle = "User Master";
    this.breadCrumbItem = "Add " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/User";
    this.API_URL_SAVE = API_WEB_URLS.UserMaster + "/0/token";
    this.pushFormName = "/UserMaster";
    this.rtPage_Print = "/membersynopsisprint";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
  }

  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (this.nameFieldRef.current) {
      this.nameFieldRef.current.focus();
    }
    this.setState({
      name: obj.username,
      email: obj.email,
      aid: obj.uid,
      role: obj.role,
    });
    
    Fn_FillListData(
      this.obj,
      "UserType",
      API_WEB_URLS.MASTER + "/0/token/UserType/Id/0"
    );
    //Filling DropDowns
   
    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      Fn_DisplayData(this.obj, id, this.API_URL + "/Id");
    } else {
      this.setState({ id: 0 });
    }
  }

  btnSave_onClick(event, formData) {
    let vformData = new FormData();

    vformData.append("Name", formData.Name);
    vformData.append("Password", formData.Password);
    vformData.append("F_UserType", formData.F_UserType);
    vformData.append("UserId", this.state.aid);
    if (!this.state.id) {
      Fn_AddEditData(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "memberid"
      );
    } else
      Fn_AddEditData(
        this.obj,
        { arguList: { id: this.state.id, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "kuku"
      );

  }

  btnGoBack_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  btnCancel_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  render() {
    return (
      <div className="page-content">
        <Container fluid>
          {/* Tabs */}
          <div style={{ 
            borderBottom: '2px solid #00ff00',
            marginBottom: '20px'
          }}>
            <Row>
              <Col>
                <div style={{ display: 'flex', gap: '2px' }}>
                
                  <div style={{
                    padding: '10px 20px',
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #ddd',
                    borderBottom: 'none',
                    cursor: 'pointer'
                  }}>
                    Customer Profile
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {/* Registration Time */}
          <div style={{ 
            textAlign: 'right',
            marginBottom: '20px',
            color: '#666',
            fontSize: '14px'
          }}>
            Registration Time(hh:mm:ss) : 00:00:19
          </div>

          {/* Form Content */}
          <div style={{ padding: '20px' }}>
            {/* UID/VID Selection */}
            <div className="mb-4">
              <Label className="d-inline-block mr-4">
                <Input
                  type="radio"
                  name="idType"
                  checked={this.state.idType === 'UID'}
                  onChange={() => this.setState({ idType: 'UID' })}
                  className="mr-2"
                /> UID
              </Label>
              <Label className="d-inline-block">
                <Input
                  type="radio"
                  name="idType"
                  checked={this.state.idType === 'VID'}
                  onChange={() => this.setState({ idType: 'VID' })}
                  className="mr-2"
                /> VID
              </Label>
            </div>

            {/* Aadhaar Number Input */}
            <div className="mb-4">
              <Label>
                Aadhaar Number <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                type="text"
                value={this.state.aadhaarNumber}
                onChange={(e) => this.setState({ aadhaarNumber: e.target.value })}
                style={{ maxWidth: '300px' }}
              />
            </div>

            {/* Capture Biometric */}
            <div className="text-center mb-4">
              <div style={{
                display: 'inline-block',
                padding: '20px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                textAlign: 'center'
              }}>
                <i className="mdi mdi-fingerprint font-size-24 mb-2"></i>
                <div>Capture Biometric</div>
              </div>
            </div>

            {/* Consent Checkbox */}
            <div className="mb-4">
              <Label className="d-flex align-items-start">
                <Input
                  type="checkbox"
                  checked={this.state.consentChecked}
                  onChange={(e) => this.setState({ consentChecked: e.target.checked })}
                  className="mt-1 mr-2"
                />
                <span style={{ fontSize: '14px' }}>
                  I hereby give my consent to Fino Payments Bank to obtain my details stored with UIDAI for authentication and e-KYC purpose. Fino Payments Bank Limited has informed me that my identity information would only be used for account opening request and for DBT seeding (only if I have given consent for seeding my account with Fino Payments Bank Limited) purpose and that my Aadhaar biometrics will not be stored with the Bank.
                </span>
              </Label>
            </div>

            {/* Bottom Section */}
            <div className="d-flex justify-content-between align-items-center">
              <Button
                color="dark"
                style={{ backgroundColor: '#000' }}
              >
                Previous
              </Button>
              <div style={{ color: '#666', fontSize: '14px' }}>
                Note: Field Marked With * are Mandatory
              </div>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}
export default compose(container)(Screen3);
